import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@nomoh-monorepo/data-access-auth';

async function aguardarAuthLoading(authService: AuthService): Promise<void> {
  if (!authService.$loading()) {
    return;
  }

  await new Promise<void>((resolve) => {
    const checkLoading = () => {
      if (!authService.$loading()) {
        resolve();
      } else {
        setTimeout(checkLoading, 50);
      }
    };
    checkLoading();
  });
}

function redirecionarLogin(
  router: Router,
  route: Parameters<CanActivateFn>[0]
): false {
  const hasActivationParams =
    route.queryParams['token'] && route.queryParams['id'];

  if (hasActivationParams) {
    router.navigate(['/login'], {
      queryParams: {
        token: route.queryParams['token'],
        id: route.queryParams['id'],
      },
    });
  } else {
    router.navigate(['/login']);
  }

  return false;
}

export const authGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await aguardarAuthLoading(authService);

  if (!authService.$sessionVerified()) {
    await authService.checkSession();
  }

  if (authService.$isAuthenticated()) {
    if (authService.redirecionarSePlanoBloqueado()) {
      return false;
    }
    return true;
  }

  return redirecionarLogin(router, route);
};
